var _rect, _circle, _path, _path2, _path3, _path4, _path5, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNpsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_7893",
    "data-name": "Group 7893",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.918,
    height: 27.917,
    viewBox: "0 0 24.918 27.917",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_381",
    "data-name": "Rectangle 381",
    width: 19.841,
    height: 26.241,
    rx: 2,
    fill: "#90205d"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_300",
    "data-name": "Ellipse 300",
    cx: 5.554,
    cy: 5.554,
    r: 5.554,
    transform: "translate(12.999 16.132)",
    fill: "#90205d"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5053",
    "data-name": "Path 5053",
    d: "M371.593,446.952l-10.638.325a3.331,3.331,0,0,1-3.21-3.437V424.473a3.331,3.331,0,0,1,3.21-3.436h13.424a3.332,3.332,0,0,1,3.207,3.436q-.006,5.357-.012,10.715c-.291-.008-.6-.009-.913,0q-.409.011-.788.041-.019-5.378-.038-10.756a1.515,1.515,0,0,0-1.459-1.562h-13.42a1.515,1.515,0,0,0-1.459,1.562v19.368a1.515,1.515,0,0,0,1.459,1.562l10.278.07c.611.207.906.727.807,1.07A.716.716,0,0,1,371.593,446.952Z",
    transform: "translate(-357.745 -421.037)",
    fill: "#90205d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5054",
    "data-name": "Path 5054",
    d: "M385.057,457.782H373.494a.822.822,0,1,1,0-1.634h11.563a.822.822,0,1,1,0,1.634Z",
    transform: "translate(-369.581 -447.149)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5055",
    "data-name": "Path 5055",
    d: "M379.707,477.563h-6.271a.818.818,0,1,1,0-1.634h6.271a.818.818,0,1,1,0,1.634Z",
    transform: "translate(-369.58 -462.809)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5056",
    "data-name": "Path 5056",
    d: "M380.805,442.452h-7.041c-.648,0-1.175-.364-1.177-.816s.524-.818,1.173-.819H380.8c.648,0,1.174.366,1.174.817s-.526.817-1.174.817Z",
    transform: "translate(-369.588 -436.311)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5205",
    "data-name": "Path 5205",
    d: "M409.276,488.148a6.459,6.459,0,1,1,6.459-6.459h0A6.467,6.467,0,0,1,409.276,488.148Zm0-11.428a4.968,4.968,0,1,0,4.968,4.968A4.968,4.968,0,0,0,409.276,476.721Z",
    transform: "translate(-390.816 -460.231)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7895",
    "data-name": "Group 7895",
    transform: "translate(0.264 0.895)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5052",
    "data-name": "Path 5052",
    d: "M422.425,502.58h-5.173a.71.71,0,0,1,0-1.42h5.174a.71.71,0,0,1,0,1.42Z",
    transform: "translate(-401.547 -481.306)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5052-2",
    "data-name": "Path 5052",
    d: "M5.879,1.42H.706A.71.71,0,0,1,.7,0H5.879a.71.71,0,0,1,0,1.42Z",
    transform: "translate(19.001 17.272) rotate(90)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNpsIcon);
export default __webpack_public_path__ + "static/media/npsIcon.b8c30f13.svg";
export { ForwardRef as ReactComponent };